import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IsDynamicExtensionSlidePipe } from 'shared/classroom/preview-screen/ui-input-pipes';
import { PcpStreamingModule } from '@pcp/streaming';
import { AddToFavoritesButtonComponent } from "../components/add-to-favorites-button/add-to-favorites-button.component";
import { SlidePreviewElementComponent } from './slide-preview-element/slide-preview-element.component';
import { SlidePreviewComponent } from './slide-preview.component';
import { NextSlidesPreviewComponent } from './next-slides-preview/next-slides-preview.component';
import { NextSlidesPreviewGlassmorphicComponent } from './next-slides-preview/next-slides-preview-glassmorphic.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { EmmIframeComponent } from 'shared/classroom/preview-screen/slide-rendering/ui';
import {
    TeacherPreviewHtmlElementsModule,
    PcpRubberElementComponentModule,
    DifficultQuestionElementComponent,
    VotingElementComponent,
    VdoElementComponent,
} from 'shared/classroom/preview-screen/slide-rendering';
// eslint-disable-next-line @nx/enforce-module-boundaries -- known umbrella-level cycle, inversion planned: the preview screen must mount extension apps via a registry token instead of importing the integration lib (docs/architecture-review-classroom.md F6/R6)
import { ExtensionAppIntegrationModule } from 'extension-apps/integration';
import { SharedUiIconsModule } from 'shared/ui/icons';
import { SharedUiIconButtonModule } from 'shared/ui/icon-button';
import { SharedUiResizeObserverModule } from 'shared/ui/resize-observer';
import { SharedClassroomPreviewScreenUiInputPipesModule } from 'shared/classroom/preview-screen/ui-input-pipes';
import { SharedUiSwiperModule } from 'shared/ui/swiper';
import { SharedClassroomToolbarFeatureShellModule } from 'shared/classroom/toolbar/feature-shell';
import { FullscreenButtonComponent } from "../components/fullscreen-button.component";
import { CdkDrag } from "@angular/cdk/drag-drop";

@NgModule({
    exports: [
        SlidePreviewComponent,
        SlidePreviewElementComponent,
        DifficultQuestionElementComponent,
        VotingElementComponent,
        VdoElementComponent,
        TeacherPreviewHtmlElementsModule,
        SharedClassroomToolbarFeatureShellModule,
        PcpRubberElementComponentModule,
    ],
    imports: [
        CommonModule,
        PcpStreamingModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        ScrollingModule,
        PcpRubberElementComponentModule,
        TeacherPreviewHtmlElementsModule,
        SharedClassroomToolbarFeatureShellModule,
        ExtensionAppIntegrationModule,
        SharedUiIconsModule,
        SharedUiIconButtonModule,
        SharedUiResizeObserverModule,
        SharedClassroomPreviewScreenUiInputPipesModule,
        SharedUiSwiperModule,
        FullscreenButtonComponent,
        CdkDrag,
        SlidePreviewComponent,
        SlidePreviewElementComponent,
        AddToFavoritesButtonComponent,
        NextSlidesPreviewComponent,
        NextSlidesPreviewGlassmorphicComponent,
        DifficultQuestionElementComponent,
        VotingElementComponent,
        VdoElementComponent,
        EmmIframeComponent,
        IsDynamicExtensionSlidePipe,
    ],
})
export class TeacherPreviewScreenModule {}
